import type { IContest } from '../../types/global/helper';

/** True when loaded contest matches the manage-route param (slug, _id, or contest_id). */
export function contestMatchesRouteRef(routeRef: string | undefined, contest: IContest | null | undefined): boolean {
    if (!routeRef || !contest) return false;
    if (routeRef === contest._id || routeRef === contest.slug) return true;
    const contestId = contest.contest_id ?? contest.id;
    return Boolean(contestId && routeRef === contestId);
}
